export const googleFormEnglish = "https://forms.gle/STP6zZxiPz1n2QEG6";
export const googleFormKorean = "https://forms.gle/QaYuSgMXuiybUnfp7";

export const diagnosisPrice = 59;
export const corePrice = 149;
export const signaturePrice = 299;
export const mainPrice = signaturePrice;

export const SERVICE_PRICES: Record<string, number> = {
  diagnosis: diagnosisPrice,
  core: corePrice,
  signature: signaturePrice,
};

export const DIGITAL_PRICES = {
  "resume-kit": 4.99,
  "interview-guide-student": 4.99,
  "interview-guide-experienced": 6.99,
  "linkedin-guide": 6.99,
  "digital-bundle": 19.99,
} as const;

export const presaleCheckLink = "https://go.bemeconsulting.com/presale-dia-pay";
export const presaleCoreLink = "https://go.bemeconsulting.com/presale-ess-pay";
export const presaleSignatureLink = "https://go.bemeconsulting.com/presale-sig-pay";
